import { render, staticRenderFns } from "./start-examine.vue?vue&type=template&id=23486f9a&scoped=true&"
import script from "./start-examine.vue?vue&type=script&lang=js&"
export * from "./start-examine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23486f9a",
  null
  
)

export default component.exports